import React, { useState } from 'react';

const Disclaimer = () => {
    return (
        <>
            <div className="col-12 mt-3">
                <h2 className="panel-name">Disclaimer</h2>
            </div>
            <div className="col-12" style={{ lineHeight: 20 + 'px' }}>
                <p>
                    All rights reserved. No part of this publication may be reproduced,
                    distributed or transmitted in any form or by any means, including
                    photocopying or other eletronic or mechanical method without the prior
                    expressed written permission of Dr Lal PathLabs.
                </p>
                <ul>
                    <li>
                        Dr Lal PathLabs will not be liable for any indirect, direct,
                        special, consequential or other damages.

                    </li>
                    <li>
                        This report is not indended to replace your doctor. Please
                        make sure you consult your doctor before further actions.
                    </li>
                    <li>
                        Please be careful of any food allergies or intolerances that
                        you are sensitive to.
                    </li>
                    <li>
                        Analysis uses Blood data only.
                    </li>
                    <li>
                        The analyzed information in this report is not applicable for
                        individuals less than 18 years of age and pregnant women.
                    </li>
                </ul>
            </div>
        </>
    )
}

export default Disclaimer;